import { Product } from "./Order.interface";

export const searchInProduct =
  (text = "") =>
  (product: Product): boolean =>
    product.id.includes(text) ||
    product.itemName.toLowerCase().includes(text) ||
    product.brand.toLowerCase().includes(text) ||
    product.category.toLowerCase().includes(text);
